import React from 'react';
import { WebinarsPage, WebinarDetail } from '@BUP/pages';
import { Route, useRouteMatch, Switch } from 'react-router-dom';

const WebinarsNavigation = () => {
  const match = useRouteMatch();
  return (
    <Switch>
      <Route component={WebinarsPage} path="/webinars" exact />
      <Route
        component={WebinarDetail}
        path={`${match.path}/:webinarId`}
        exact
      />
    </Switch>
  );
};
export default WebinarsNavigation;
